// extracted by mini-css-extract-plugin
export default {"component":"app-menu-component_component_B8gua","logout":"app-menu-component_logout_pWWey"};